export const createTicketSlice = (set, get) => ({
  ticket: {
    data: null,
    loading: false,
    error: '',
  },
  ticketActions: {
    setLoading: (loading) =>
      set((state) => { state.ticket.loading = loading }),
  
    setData: (data) =>
      set((state) => { state.ticket.data = data }),
  
    setError: (error) =>
      set((state) => { state.ticket.error = error }),
  }
});
